import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { CustomerListLoadingItemDesktop } from './desktop';
import { ListLoadingItemMobile } from './mobile';
import { ListLoadingItemTablet } from './tablet';

export const CustomerListLoadingItem: React.FC = () => {
  const customerListLoadingItem = useBreakpointValue({
    base: <ListLoadingItemMobile />,
    sm: <ListLoadingItemTablet />,
    lg: <CustomerListLoadingItemDesktop />,
  });

  return customerListLoadingItem;
};
